import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from 'src/app/service/loader.service';
import { RestService } from 'src/app/service/rest.service';
import { MatDialogComponent } from '../../dialog-box/mat-dialog/mat-dialog.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-mfa-tranaction',
  templateUrl: './mfa-tranaction.component.html',
  styleUrls: ['./mfa-tranaction.component.scss']
})
export class MfaTranactionComponent implements OnInit {
  mfaForm: FormGroup;
  selectedOptionsControl: FormControl;
  authenticationTypes!: any[]
  radioOptions: any[];
  checkboxOptions: any[];
  submitClicked = false;
  selectedOptions: any = [];
  selectionReq: boolean = false;
  navigateUrl: string = '';
  primary: boolean = false;
  mfaauthenticationTypes!: any[]
  @Input() uniqueCode: string = '';
  @Output() MFATransactionSuccess: EventEmitter<string> = new EventEmitter<string>();


  constructor(
    private fb: FormBuilder,
    private restService: RestService,
    private loader: LoaderService,
    private translate: TranslateService,
    private dialog: MatDialog, private route: ActivatedRoute
  ) {
    this.mfaForm = this.fb.group({
      selectedRadioOption: ['', Validators.required], // Required validator for radio button
      checkboxes: this.fb.group({}), // Custom validator for checkboxes
    }, { validators: this.checkAtLeastOneCheckbox });

    this.selectedOptionsControl = new FormControl('');
    this.mfaForm.addControl('selectedOptions', this.selectedOptionsControl);

    this.radioOptions = [];
    this.checkboxOptions = [];
  }

  ngOnInit(): void {
    this.route.url.subscribe(url => {
      this.navigateUrl = url[0].path;
    });
    setTimeout(() => {
      this.getData();
    }, 400)
    if (this.navigateUrl === 'edit-mfa-transactions') {
      this.getEditMfaData()
    }
  }

  getData() {
    this.loader.show();
    let url = 'api/digital/core/UserActivation/FetchallAuthentificationTypes'
    let params
    if (this.navigateUrl === 'edit-mfa-transactions') {
      params = null;
    }
    else {
      params = {
        "authenticationUniqueCode": this.uniqueCode
      }
    }
    this.restService.postUATData(params, url).subscribe(
      {
        next: (data: any) => {
          if (data.rcode == 200) {
            this.loader.hide()
            this.authenticationTypes = data.rObj.authenticationTypes;
            if (this.authenticationTypes.length != 0) {
              this.processAuthenticationTypes();
            }
          }
          else {
            this.loader.hide();
            let a = data.rmsg[0].errorCode ?? 'ERROR'
            let err = this.translate.instant(a)
            console.error('Error Receiving data:', data);
            const dialogRef = this.dialog.open(MatDialogComponent, {
              panelClass: ['dialog-responsive'],
              disableClose: true,
              data: {
                secondary: true,
                transactionReference: data.rmsg[0].transactionReference ? data.rmsg[0].transactionReference : null,
                errorMessage: err
              }
            });
            dialogRef.afterClosed().subscribe();
          }

        },
        error: (error: any) => {
          this.loader.hide();
          let a = error.error.rmsg[0].errorCode ?? 'ERROR'
          let err = this.translate.instant(a)
          console.log(err)

          console.error('Error submitting form:', error);
          const dialogRef = this.dialog.open(MatDialogComponent, {
            panelClass: ['dialog-responsive'],
            disableClose: true,
            data: {
              error: true,
              transactionReference: error.error.rmsg[0].transactionReference ? error.error.rmsg[0].transactionReference : null, errorMessage: err,
            }
          });
          dialogRef.afterClosed().subscribe();
        }
      })

  }

  getEditMfaData() {
    this.loader.show();
    let url = 'api/digital/core/UserActivation/GetUserMFAAuthentications'

    this.restService.postUATData(null, url).subscribe(
      {
        next: (data: any) => {
          if (data.rcode == 200) {
            this.loader.hide()
            this.mfaauthenticationTypes = data.rObj.authenticationDetails;
          }
          else {
            this.loader.hide();
            let a = data.rmsg[0].errorCode ?? 'ERROR'
            let err = this.translate.instant(a)
            console.error('Error Receiving data:', data);
            const dialogRef = this.dialog.open(MatDialogComponent, {
              panelClass: ['dialog-responsive'],
              disableClose: true,
              data: {
                secondary: true,
                transactionReference: data.rmsg[0].transactionReference ? data.rmsg[0].transactionReference : null,
                errorMessage: err
              }
            });
            dialogRef.afterClosed().subscribe();
          }

        },
        error: (error: any) => {
          this.loader.hide();
          let a = error.error.rmsg[0].errorCode ?? 'ERROR'
          let err = this.translate.instant(a)
          console.log(err)

          console.error('Error submitting form:', error);
          const dialogRef = this.dialog.open(MatDialogComponent, {
            panelClass: ['dialog-responsive'],
            disableClose: true,
            data: {
              error: true,
              transactionReference: error.error.rmsg[0].transactionReference ? error.error.rmsg[0].transactionReference : null, errorMessage: err,
            }
          });
          dialogRef.afterClosed().subscribe();
        }
      })

  }

  processAuthenticationTypes(): void {
    this.authenticationTypes.forEach((type) => {
      if (type.parentActivationTypeID === 1070) {
        this.radioOptions.push(type);
      } else if (type.parentActivationTypeID === 1060 && type.isCandidateForLogin) {
        this.checkboxOptions.push(type);
        const controlName = type.authenticationTypeID;
        (this.mfaForm.get('checkboxes') as FormGroup).addControl(controlName, this.fb.control(''));
      }
    });
    if (this.navigateUrl === 'edit-mfa-transactions') {
      if (this.mfaauthenticationTypes?.length && this.authenticationTypes?.length) {
        this.authenticationTypes.forEach((authType) => {
          this.authenticationTypes.some(authType =>
            this.mfaauthenticationTypes?.some(mfaType => mfaType.mfaAuthenticationTypeID === authType.authenticationTypeID && authType.isCandidateForTransaction)
          );
          const matchingType = this.mfaauthenticationTypes.find(mfaType => mfaType.mfaAuthenticationTypeID === authType.authenticationTypeID && mfaType.isCandidateForTransaction);
          if (matchingType) {
            this.mfaForm.get('selectedRadioOption')?.setValue(authType.authenticationTypeID);
            const controlName = authType.authenticationTypeID.toString();
            const control = (this.mfaForm.get('checkboxes') as FormGroup).get(controlName);
            if (control) {
              this.mfaForm.get('selectedRadioOption')?.setValue("uniqueCode");
              control.setValue(true);
              this.selectedOptions.push(authType);
              this.mfaForm.get('selectedCheckboxes')?.setValue(this.selectedOptions);
              if (this.selectedOptions.length >= 1) {
                this.primary = true;
              } else {
                this.primary = false
              }
              if (authType.isPrimary) {
                this.selectedOptionsControl.setValue(authType.authenticationTypeID)
              }
            }
          }

        })

      }
    }
  }





  checkAtLeastOneCheckbox(group: FormGroup) {
    const selectedRadioOption = group.get('selectedRadioOption')?.value;
    const checkboxes = group.get('checkboxes') as FormGroup;
    const selectedCheckboxes = Object.values(checkboxes.controls).filter((control) => control.value === true);

    if (selectedRadioOption === 'uniqueCode' && selectedCheckboxes.length === 0) {
      return { noCheckboxSelected: true };
    }

    return null;
  }

  onRadioChange(event: any): void {
    const checkboxes = this.mfaForm.get('checkboxes') as FormGroup;

    // Reset the values of all checkbox controls
    Object.keys(checkboxes.controls).forEach((controlName) => {
      checkboxes.get(controlName)?.setValue(false);
    });

    this.selectedOptions = [];
    this.primary = false;
    this.selectedOptionsControl.setValue('')
  }

  selectChange() {
    this.selectionReq = false;
  }

  onFormSubmit(title) {
    let value;
    if(title =='submit'){
      this.submitClicked = true;
    this.submitClicked = true;
    // this.selectedOptions.markAllAsTouched()
    let checkboxValue: any
    let primaryValue: any
    if (this.mfaForm.invalid || (this.selectedOptionsControl.value === '' && this.mfaForm.value.selectedRadioOption == "uniqueCode")) {
      this.selectionReq = true;
    } else {
      this.selectionReq = false;
      if (this.mfaForm.value.selectedRadioOption == "uniqueCode") {
        checkboxValue = this.mfaForm.value.checkboxes
        primaryValue = this.selectedOptionsControl?.value
        const authenticationDetails: { mfaAuthenticationTypeID: number; isPrimary: boolean }[] = [];

        // Iterate through the keys in the dynamic object
        Object.keys(checkboxValue).forEach(key => {
          if (checkboxValue[key]) {
            // Convert the key to a number to use as mfaAuthenticationTypeID
            const mfaAuthenticationTypeID = parseInt(key, 10);
            const isPrimary = primaryValue == mfaAuthenticationTypeID;

            // Push the object into the new array
            authenticationDetails.push({
              mfaAuthenticationTypeID,
              isPrimary,
            });
          }
        })
        value = authenticationDetails
      } else {
        let val = this.mfaForm.value.selectedRadioOption
        const authenticationDetails = [];
        authenticationDetails.push({
          mfaAuthenticationTypeID: val,
          isPrimary: true// Adjust the condition as needed
        });
        value = authenticationDetails
      }
      this.submitMFAform(value,title)
    }
  }
  else{
    const authenticationDetails = [];
    authenticationDetails.push({
      mfaAuthenticationTypeID: null,
      isPrimary: false// Adjust the condition as needed
    });
    value = authenticationDetails
    this.submitMFAform(value,title)
  }
  }

  submitMFAform(authenticationDetails: any,title:any) {
    let url
    let params
    let msg=''
    if (this.navigateUrl === 'edit-mfa-transactions') {
      params = {
        authenticationDetails,
      }
      url = 'api/digital/core/User/EditUserMFAForTransaction',
      msg = "MFA for transaction detail(s) updated successfully!."

    }
    else {
      params = {
        authenticationDetails,
        "authenticationUniqueCode": this.uniqueCode ? this.uniqueCode : null,
        "isMFAForTransactionSkipped": title == 'submit' ? false : true
      }
      url = 'api/digital/core/UserActivation/InsertUserMFAForTransaction',
      msg = "Multi-Factor Authentication (MFA) has been successfully set up for all transactions in the system!."
    }

    this.restService.postUATData(params, url).subscribe(
      {
        next: (data: any) => {
          if (data.rcode == 200) {
            this.loader.hide();
            let SUCCESS = true;
            // this.MFATransactionSuccess.emit(data)
            let _dialogRef = this.dialog.open(MatDialogComponent, {
              width: '50VW',
              disableClose: true,
              data: {
                success: true,
                trnID: data.transactionRef,
                errorMessage: title == 'submit' ? msg : "MFA was successfully skipped for this transaction!."
              }
            })
            _dialogRef.afterClosed().subscribe(result => {
              if (result) {
                // if(this.navigateUrl ='mfa-transactions'){
                // history.back()
                // }
               this.MFATransactionSuccess.emit(data)
              }
            })
          }
          else {
            this.loader.hide();
            let a = data.rmsg[0].errorCode ?? 'ERROR'
            let err = this.translate.instant(a)
            console.error('Error Receiving data:', data);
            const dialogRef = this.dialog.open(MatDialogComponent, {
              panelClass: ['dialog-responsive'],
              disableClose: true,
              data: {
                secondary: true,
                transactionReference: data.rmsg[0].transactionReference ? data.rmsg[0].transactionReference : null,
                errorMessage: err
              }
            });
            dialogRef.afterClosed().subscribe();
          }

        },
        error: (error: any) => {
          this.loader.hide();
          let a = error.error.rmsg[0].errorCode ?? 'ERROR'
          let err = this.translate.instant(a)
          console.log(err)

          console.error('Error submitting form:', error);
          const dialogRef = this.dialog.open(MatDialogComponent, {
            panelClass: ['dialog-responsive'],
            disableClose: true,
            data: {
              error: true,
              transactionReference: error.error.rmsg[0].transactionReference ? error.error.rmsg[0].transactionReference : null, errorMessage: err,
            }
          });
          dialogRef.afterClosed().subscribe();
        }
      })

  }



  updateSelectedCheckboxes(option: any, event: any) {

    if (event.checked) {
      // Checkbox is selected, add the option to the selectedOptions array
      this.selectedOptions.push(option);
      if (this.selectedOptions.length === 1) {
        // this.selectedOptionsControl.setValue
      }
    } else {
      // Checkbox is deselected, remove the option from the selectedOptions array
      this.selectedOptions = this.selectedOptions.filter((selectedOption: any) => selectedOption !== option);
    }

    // Update the form control value based on the selected checkboxes
    this.mfaForm.get('selectedCheckboxes')?.setValue(this.selectedOptions);
    if (this.selectedOptions.length >= 1) {
      this.primary = true;
    } else {
      this.primary = false
    }
  }
}
